import React from 'react'
import styled from 'styled-components'

import Image from '../../atoms/Image'
import { MysqlProducts } from '../../graphqlTypes'

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.border.main};
  border-radius: 5px;
  box-sizing: border-box;
  padding: 12px;
  width: 100%;
`

const List = styled.ul`
  list-style: none;
  margin: 8px 0 0;
`

const ListItem = styled.li`
  margin: 4px 0 0;
  &:first-child {
    margin: 8px 0 0;
  }
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 8px 0 0;
    &:first-child {
      margin: 12px 0 0;
    }
  }
`

const CheckIconBox = styled(Image)`
  display: inline-block;
  margin: 0 5px 0 0;
  vertical-align: middle;
  width: 16px;
  height: 16px;
`

const Text = styled.span`
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    font-size: 14px;
  }
`

type Props = {
  product: MysqlProducts
  variantHeading?: 'h2' | 'h3' | 'p'
}

export default function RecommendList({ product, variantHeading }: Props) {
  const recommendation = (product.recommendation || '').trim()
  if (!recommendation) return null

  const Heading = styled[variantHeading || 'p']`
    background: ${({ theme }) => theme.palette.primary.main};
    border-radius: 30px;
    color: ${({ theme }) => theme.palette.font.light};
    display: inline;
    font-size: 10px;
    font-weight: bold;
    padding: 5px 10px;
  `

  return (
    <Container>
      <Heading>{product.name}のおすすめポイント</Heading>
      <List>
        {recommendation.split('\n').map((text, index) => (
          <ListItem key={index}>
            <CheckIconBox alt={`おすすめポイント ${index + 1}つ目`} filename="icon-check-box.png" />
            <Text>{text}</Text>
          </ListItem>
        ))}
      </List>
    </Container>
  )
}
